import React from "react";
import { connect } from "react-redux";
import DynamicMainScreen from "../../components/dynamicscreens/DynamicMainScreen";
import { CarryForwardLeaveProcessColumns } from "../../tableColumns/table-columns";
import { CarryForwardLeaveProcessJson } from "../../DynamicFormsJson/Transaction/carryForwardLeaveProcess";
import { withRouter } from "../../components/withRouter";
import { compose } from "recompose";
import { getActiveSalesTeamByUserTypeIds } from "../../Slice/salesExecutive.slice";
import { noInternetMsg, serverMsg } from "../../config/messageconstant";
import { showLoador, showNotification } from "../Landing/Landing.slice";

class CarryForwardLeaveProcess extends React.Component {
    constructor(props) {
        super(props);
    }

    async componentDidMount() {
        if (navigator.onLine) {
            this.getData();
        } else {
            this.props.showNotification({ msg: noInternetMsg, severity: "error" });
        }
    }

    getData = async () => {
        const { getActiveSalesTeamByUserTypeIds, showLoador, showNotification } = this.props;

        let dataJson = {
            userTypeIds: [3, 4],
        }
        showLoador({ loador: true });
        await getActiveSalesTeamByUserTypeIds({ userTypeIdsData: dataJson }).then(({ response, success }) => {
            if (!success) {
                showNotification({
                    msg: serverMsg,
                    severity: "error",
                });
            }
        });
        showLoador({ loador: false });
    }


    rowTransfer = (rowData) => {
        this.props.navigate(CarryForwardLeaveProcessJson.openFormPathStatus + "/" + rowData.id);
    }

    render() {
        const { salesTeamList } = this.props;
        return (
            <>
                <DynamicMainScreen
                    callApi={false}
                    formPath={CarryForwardLeaveProcessJson.formPath}
                    screenTitle={CarryForwardLeaveProcessJson.screenTitle}
                    fieldMeta={CarryForwardLeaveProcessJson.fieldMeta}
                    showPdfDownload={false}
                    showExcelDownload={true}
                    changeExcelURL={CarryForwardLeaveProcessJson.excelUrl}
                    showExtension={false}
                    filterDataExcel={true}
                    pdfFileName={CarryForwardLeaveProcessJson.pdfFileName}
                    excelFileName={CarryForwardLeaveProcessJson.excelFileName}
                    showAddButton={false}
                    tableColumnsToFilter={CarryForwardLeaveProcessJson.tableColumnsToFilter}
                    tableColumns={CarryForwardLeaveProcessColumns}
                    tableData={salesTeamList?.salesPersonByArea}
                    getTableData={this.getData}
                    apiBaseURL={CarryForwardLeaveProcessJson.apiBaseURL}
                    baseIdColumn={CarryForwardLeaveProcessJson.baseIdColumn}
                    showDeleteIcon={false}
                    showViewButtonInTable={true}
                    formPathView={CarryForwardLeaveProcessJson.formPathView}
                    isActiveURL={CarryForwardLeaveProcessJson.isActiveURL}
                    showEditIcon={false}
                    showTransferButtonInTable={true}
                    showTransferTitle={"Carry Forward Process"}
                    autoTransfer={false}
                    rowTransfer={this.rowTransfer}
                />
            </>
        );
    }
}
const mapStateToProps = (state) => ({
    carryForwardLeaveList: state.year,
    salesTeamList: state.salesExecutive
});
const mapDispatchToProps = {
    getActiveSalesTeamByUserTypeIds,
    showLoador,
    showNotification,
};

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(CarryForwardLeaveProcess);
